// Router-agnostic canvas context hook

export function useCanvasContext() {
  const isCanvas =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('canvas') === 'true';

  return {
    isCanvas,
    getCleanUrl: (pathname: string) => {
      if (isCanvas) {
        return `${pathname}?canvas=true`;
      }
      return pathname;
    },
  };
}
